import FullWidthVideo from '../fullWidthVideo';
import clientConfig from '../../client.config';
import {useTranslation} from 'next-i18next';

export default function CategoryOverview({
                                           categoryOverview,
                                           categoryOverviewMarkdown,
                                           isModelCategory,
                                         }) {

  const {
    heroVideo,
    videoThumbnail,
    videoTitle,
    videoDescription,
  } = categoryOverview;
  const {url: videoUrl} = categoryOverview.heroVideo;
  const {categoryDescription} = categoryOverview;
  const {t: translateSiteMeta} = useTranslation('site-meta');

  return <>

    <FullWidthVideo
        video={heroVideo}
        poster={videoThumbnail}
    />
    <section>
      <center>
        <div
            className={'bg-gray-50 w-4/5 md:w-3/4 xl:w-1/2 py-6 px-6 md:px-10 lg:px-20'}>
          <div
              className={'font-title text-2xl md:text-5xl uppercase tracking-normal '}
              dangerouslySetInnerHTML={{__html: categoryOverviewMarkdown.pageTitle}}/>
          {isModelCategory && <h2
              className={'mb4 md:mb-8 font-title tracking-wide uppercase md:text-xl text-red-800'}>{translateSiteMeta(
              'SLOGAN')}</h2>}

          <p className={'text-gray-600'}>
            {categoryDescription}
          </p>
        </div>
      </center>
    </section>

  </>;

}
